import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';
import './App.css';

import Carousel from './carousel';
import PaymentForm from './paymentForm';
import TrackEvent from './event';

class App extends Component {
  constructor(props){
    super(props);

    TrackEvent.view();
    
    this.loadOffer = this.loadOffer.bind(this);
    this.changeSubscription = this.changeSubscription.bind(this);
    this.toggleForm = this.toggleForm.bind(this);

    this.state = {
      offer: {},
      subscriptions: [],
      subscription: {},
      selected: 0,
      paymentForm: false
    }
  }

  componentWillMount(){
    this.loadOffer();
  }

  changeSubscription(n){
    var newSubscription = this.state.subscriptions[n]
    
    this.setState({
      selected:n,
      subscription: newSubscription
    })

    TrackEvent.event({
      category: "productBtn-" + newSubscription.title,
      action: "click"
    })
  }

  loadOffer(){
    
    var _this = this;
  
    var offersURL = "/offers/info/0";

    // offersURL = "http://127.0.0.1:3000/offers/0"
    
    fetch(offersURL)
      .then(function(response){
        if(response.status !== 200){
          console.log("Error fetching offers")
        }

        response.json().then(function(data){
          _this.setState({
            offer: {
              title: data.title,
              subtitle: data.subtitle,
              description: data.description,
              specs: data.specs
            },
            subscriptions: data.subscriptions,
            subscription: data.subscriptions[0]
          })
        })
      }).catch(function(err){

        // _this.setState({
        //   offer: {
        //     title: "Premium Subscription",
        //     subtitle: "Enjoy a Faster and Safer Internet with our All-In-One Tracker Blocker and VPN",
        //     description: "The internet sees and can track pretty much everything. The world’s most powerful companies and politicians collect as much of our valuable personal information as they can. Cybercriminals are also constantly trying to gain access to our accounts and identities. Disconnect Premium empowers you to control your privacy and makes your desktop and mobile experience faster and safer, also improving battery life and reducing wasted cellular data. Disconnect Premium gives you the ability to block and visualize tracking across your entire device, protecting you inside all the apps and browsers you use.\n\n#### Features:\n* Block and view tracking requests and other threats\n* By preventing tracking connections to your device, accelerate page load speed and reduce data usage\n* Protection across all your applications, including mobile browsers (Safari, Chrome, Firefox, Opera, etc.)\n* Allows you to encrypt all Internet connections, to prevent Wi-Fi snooping, ISP tracking and other forms of surveillance\n* Masks your location so you can access content as if you’re in a different country\n\n#### About us:\n* Over 50 million people rely on our protection\n* Amazing accolades include winning the Innovation Award for Privacy and Security at the South by Southwest Interactive festival, making the list of Popular Science’s 100 Best of What’s New and being recommended several times as the New York Times' favorite privacy app\n* Featured on 60 Minutes, the Wall Street Journal, the Today Show, CNN, Wired, and many more\n* Public partnerships with leading privacy/security organizations like the EFF and Mozilla",
        //     specs: "Compatibility\n* iOS\n* Android\n* Mac OS X\n* Windows\n\nTerms\n* All sales final\n* Instant digital redemption"
        //   },
        //   subscriptions: [
        //     {
        //       id: "prod_B2mPzoYhEEzUji",
        //       title: "Lifetime",
        //       price: 49,
        //       regularPrice: 500,
        //       off: 90
        //     },
        //     {
        //       id: "prod_B37tcI6WTrXXjg",
        //       title: "3-year",
        //       price: 29,
        //       regularPrice: 150,
        //       off: 80,
        //     },
        //     {
        //       id: "marketingOffer1",
        //       title: "1-year",
        //       price: 19,
        //       regularPrice: 50,
        //       off: 62
        //     }
        //   ],
        //   subscription: {
        //     id: "prod_B2mPzoYhEEzUji",
        //     title: "Lifetime",
        //     price: 49,
        //     regularPrice: 500,
        //     off: 90
        //   }
        // })
      })
  }

  toggleForm(override){
    var newState = override !== undefined ? override : !this.state.paymentForm;

    this.setState({paymentForm: newState})    
    
    if(newState){
      document.body.style.overflow = "hidden"
      document.body.style.position = "fixed"      
    } else {
      document.body.style.overflow = ""
      document.body.style.position = ""
    }
    
    TrackEvent.event({
      category: "CTA-Checkout",
      action: "click"
    })
  }
  
  render() {

    var sSub = this.state.selected;
    var _this = this;

    var subscriptionBtns = this.state.subscriptions.map(function(sub,i){
      var active = sSub === i ? true : false;
      var classes = classNames("sm-col sm-col-12 md-col-5 border p1 mr1 mb1 center btn-subscription", {active:active})
      
      return (
        <div className={classes} key={i} onClick={() => _this.changeSubscription(i)}>
          <span className="s-title block">{sub.title}</span>
          <span className="s-price">${sub.price} </span>
          <span className="s-regularPrice">${sub.regularPrice}</span>
        </div>
      )
    })
    
    return (
      <div className="App">
        { this.state.paymentForm === true &&
          <PaymentForm subscription={this.state.subscription} close={() => this.toggleForm(false)}/>
        }
        <div className="max-width-4 mx-auto">
          <div className="badge xs-hide">
              <div className="p1">
                <a href="http://www.nytimes.com/2016/02/18/technology/personaltech/free-tools-to-keep-those-creepy-online-ads-from-watching-you.html" target="_blank"  rel="noopener">
                  <span className="block">Named favorite privacy tool!</span>
                  <img className="block" src="https://s3.amazonaws.com/images.disconnect.me/images/offers/The_New_York_Times.png" alt="Favorite Privacy Tool!" />
                  <small className="m0 block">February 12, 2016</small>
                </a>                
              </div>
          </div>
          <div className="clearfix">
            <div className="col col-12 mt4 pl2">
                <img id="logo" src="https://s3.amazonaws.com/images.disconnect.me/images/v5/shield-logo.svg" alt="Disconnect Premium"/>
            </div>
            <div className="sm-col lg-col-12 pb2 pl2">
                <h1 className="mb0 mt2">Take back control of your privacy</h1>
                <h2 className="h3 m0">{ this.state.offer.subtitle }</h2>
            </div>
            <Carousel />
            <div id="pricing" className="sm-col sm-col-12 md-col-4 pl2 pr2 pb2 border-top border-bottom mt2">
                <h2 className="mb0">{this.state.offer.title}: {this.state.subscription.title}</h2>
                <h3 className="h2 inline-block mt0">${this.state.subscription.price} </h3>
                <span id="regular-price" className="ml1">${this.state.subscription.regularPrice}</span>
                <span id="discount" className="ml1">{this.state.subscription.off}% off</span>
                <hr className="mb2 mt0" />
                <div className="clearfix max-width">
                  {subscriptionBtns}
                </div>
                <div className="clearfix"></div>
                <hr className="mb2 mt1"/>
                <a className="rounded pb2 pt2" id="checkout" onClick={() => this.toggleForm(true)}>Checkout</a>
            </div>
          </div>
        </div>
        <div id="info">
          <div className="max-width-4 mx-auto pt2 pb2">
            <div className="clearfix">
              <div className="sm-col col-8 pr1 pl2">
                  <h1 className="h2">Description</h1>
                  <ReactMarkdown source={this.state.offer.description} />
              </div>
              <div className="sm-col col-4 pl4 pr2">
                  <ReactMarkdown source={this.state.offer.specs} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js